// extracted by mini-css-extract-plugin
module.exports =  {"panelHeader":"panelHeader__0TyAd","iconHolder":"iconHolder__HK-Ky","title":"title__puDEJ"};